// ═══════════════════════════════════════════════════════════════════════════════
//  src/dojo/dojoFx.js
//  LOS RECORDS DEL DOJO
//
//  Aqui vivia tambien el motor de sonido. Se saco a `src/audio/fx.js` porque
//  era el unico sitio del producto que sonaba —y tambien el unico que se sentia
//  vivo, que no es casualidad—. Ahora suena toda la aplicacion desde alli.
//
//  Lo que queda es lo que de verdad es del Dojo: la marca personal de cada
//  formato. Vive en localStorage a proposito: la marca es del alumno y de su
//  dispositivo, y no depende de que el backend tenga tabla de scores todavia
//  (hoy `save-score` recibe el resultado y lo descarta). Cuando exista, esto se
//  sincroniza sin cambiar el llamador.
// ═══════════════════════════════════════════════════════════════════════════════

const KEY = 'nsl_dojo_records_v1';

function readAll() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}

export function getRecord(format) {
  return readAll()[format] ?? 0;
}

/** Guarda si supera la marca. Devuelve true solo cuando es record nuevo. */
export function saveRecord(format, value) {
  const all = readAll();
  const prev = all[format] ?? 0;
  if (value <= prev) return false;
  all[format] = value;
  try { localStorage.setItem(KEY, JSON.stringify(all)); } catch { /* modo privado */ }
  return true;
}
